export default {
  'pet-recommendations:page-title': 'Speciaal voor jouw viervoeter',
  'pet-recommendations:cdp:title:dog': 'Aanbevelingen voor jouw hond',
};
